const getRegions = () =>
  fetch(app.config.api.customerCartRegionsURL).then((res) =>
    res.json().then((regions) => regions)
  );

export default getRegions;
